import {Modal} from "../ui/components/index.js";
import {Modal as BsModal} from "bootstrap";

export class TechSupportNotification extends Modal {

    init() {
        this.bsModal = new BsModal(this.element);
        this.find('.btn-close').addEventListener('click', () => { this.onCloseBtnClick() });
    }

    onCloseBtnClick() {
        super.onCloseBtnClick();

        window.location.href = '/account#invoices';
    }
}
